import React, { useRef, useState } from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert, Button } from "flowbite-react";
import TitleStripe2 from "../../common/TitleStripe2";
import { HiPrinter } from "react-icons/hi";

const ATPV = ({ data }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const canvasRef = useRef(null);

  const handleDownloadPdf = () => {
    const base64 = data?.atpv?.pdfBase64;
    if (!base64) return;

    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "atpv-e.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const renderPdfViewer = () => (
    <div className="flex flex-col items-center justify-center gap-6 mt-6">
      <div className="w-full max-w-3xl shadow-md border rounded-lg overflow-hidden">
        <iframe
          src={`data:application/pdf;base64,${data?.atpv?.pdfBase64}`}
          width="100%"
          height="700px"
          className="border-none"
          title="ATPV-e"
        />
      </div>

      <div className="flex-shrink-0">
        <Button color="success" onClick={handleDownloadPdf} size="lg">
          <div className="flex items-center">
            <HiPrinter className="mr-2" />
            <span>Imprimir ATPV-e</span>
          </div>
        </Button>
      </div>
    </div>
  );

  return (
    <div>
      {data?.atpv?.statusRetorno == 1 ? (
        <>
          <TitleStripe2 className="mt-4">📄 ATPV-e</TitleStripe2>
          {renderPdfViewer()}
        </>
      ) : (
        <div className="mt-6">
          <TitleStripe>ATPV-e</TitleStripe>
          <Alert withBorderAccent color="gray" className="mt-5">
            Consulta indisponível no momento.
          </Alert>
        </div>
      )}
    </div>
  );
};

export default ATPV;
